module.exports = __webpack_public_path__ + "microsoft.svg";